import { sortBy } from 'lodash';
import React, { useContext, useMemo } from 'react';

import StickyPageHeader from '../components/common/StickyPageHeader';
import ModeList from '../components/lists/ModeList';
import { AuthContext } from '../contexts/authContext';
import {
  useSelectedCarrier,
  useUserPermission,
} from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierModesPage = ({ routes }) => {
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();
  const userHasPermission = useUserPermission();

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  const carrierModes = useMemo(
    () => sortBy(selectedCarrier?.modes, (mode) => mode.defaultModeId),
    [selectedCarrier]
  );

  const canView =
    !!selectedCarrier &&
    userHasPermission(selectedCarrier, 'modePermission');

  return (
    <Layout
      carrierLoading={!selectedCarrier}
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      {canView && (
        <>
          <StickyPageHeader
            subtitle={selectedCarrier.name}
            title="Modes of Transport"
          />
          <ModeList
            carrier={selectedCarrier}
            id="modes"
            modes={carrierModes || []}
            userRole={authUser?.role}
          />
        </>
      )}
    </Layout>
  );
};

export default CarrierModesPage;
